import React from "react";
import { BANNER_SECTION, FEATURES_WEBSITE } from "../../intl/copyright";
import { CardBlog } from "../../components/Section/Section.CardBlog";
import { Card } from "../../components/Section/Section.Card";
import { useMediaQuery } from "@mountain-ui/react-hooks";
import { useSelector } from "react-redux";

import ImageOne from "../../assets/images/website/w-1.webp";
import ImageOneMobile from "../../assets/images/website/w-1-mobile.webp";
import W2 from "../../assets/images/website/w-2.webp";
import W2Mobile from "../../assets/images/website/w-2-mobile.webp";
import W3 from "../../assets/images/website/w3.webp";
//import W4 from "../../assets/images/website/w4.webp";
import W5 from "../../assets/images/website/w5.webp";
//import W6 from "../../assets/images/website/w6.webp";
import W7 from "../../assets/images/website/w7.webp";
import W8 from "../../assets/images/website/w8.webp";
import SU from "../../assets/images/website/su.webp";
import CP from "../../assets/images/website/cp.webp";
import BS from "../../assets/images/website/bs.webp";

import Title from "../../components/Section/Section.Title";
import Section from "../../components/Section/Section";

import { LEADS_PRICING } from "../Pricing/pricing-data";

const Features = () => {
  const isMobile = useMediaQuery(
    "(max-width: 640px), (max-width: 640px) and (-webkit-device-pixel-ratio: 3)"
  );

  const { lang, origin, WEBSITE_DEMO_URL } = useSelector(
    (state) => state.appReducer
  );
  const copy = { ...BANNER_SECTION[lang], ...FEATURES_WEBSITE[lang] };

  return (
    <div>
      <Section>
        <Title t1={copy.header} t2={copy.title} t3={copy.subTitle} />
      </Section>

      <Section>
        <div className="flex items-center justify-center pt-5">
          <div className="grid gap-6 w-full">
            <Card
              title={copy.website.title}
              description={copy.website.description}
              action={copy.contactUs}
              background={isMobile ? ImageOneMobile : ImageOne}
              extended
              contact
            />
            <Card
              title={copy.properties.title}
              description={copy.properties.description}
              action={copy.contactUs}
              background={W3}
              contrast
              contact
            />

            <Card
              title={copy.testimonials.title}
              description={copy.testimonials.description}
              background={W5}
              action={copy.contactUs}
              contrast
              contact
            />

            <Card
              title={copy.brand.title}
              description={copy.brand.description}
              contrast
              contact
              background={W8}
              action={copy.contactUs}
            />
            <Card
              title={copy.seo.title}
              description={copy.seo.description}
              contrast
              contact
              background={W7}
              action={copy.contactUs}
            />
          </div>
        </div>
      </Section>

      <Section>
        <Title
          t1={copy.upgradeSection.header}
          t2={copy.upgradeSection.title}
          t3=""
        />
      </Section>
      <Section>
        <div className="flex items-center justify-center pt-5">
          <div className="grid gap-6 w-full">
            <Card
              title={copy.upgrade.title.replace(
                "WEBSITE_PRICE",
                LEADS_PRICING[origin].website
              )}
              description={copy.upgrade.description}
              action={copy.contactUs}
              background={isMobile ? W2Mobile : W2}
              extended
              contact
            />
          </div>
        </div>
      </Section>

      <Section>
        <Title
          t1=""
          t2={copy.trialSection.title}
          t3={copy.trialSection.subTitle}
        ></Title>
      </Section>
      <div>
        <iframe
          title="webiste-iframe"
          src={WEBSITE_DEMO_URL}
          width="100%"
          height="1000px"
        ></iframe>
      </div>

      <Section>
        <Title
          t1={copy.testimonialsSection.header}
          t2={copy.testimonialsSection.title}
          t3={copy.testimonialsSection.subTitle}
        />
      </Section>
      <Section>
        <div className="flex items-center justify-center pt-5">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full">
            <CardBlog
              href="https://teamsilvaefficity.pt/"
              description="effiCity"
              title="Bruno Silva"
              action={copy.view}
              background={BS}
              tab
            />
            <CardBlog
              href="https://catarinapedro.pt/"
              description="RE/MAX Place"
              title="Catarina Pedro"
              action={copy.view}
              background={CP}
              tab
            />
            <CardBlog
              href="https://susanalopesdasilva.pt/"
              title="Susana 
              Silva"
              description="RE/MAX Pro"
              action={copy.view}
              background={SU}
              tab
            />
          </div>
        </div>
      </Section>
    </div>
  );
};

export default Features;
